import { render, staticRenderFns } from "./EmptySlide.vue?vue&type=template&id=4e9ff1d2&scoped=true&"
import script from "./EmptySlide.vue?vue&type=script&lang=js&"
export * from "./EmptySlide.vue?vue&type=script&lang=js&"
import style0 from "./EmptySlide.vue?vue&type=style&index=0&id=4e9ff1d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9ff1d2",
  null
  
)

export default component.exports